<template lang="pug">
v-layout.px-3(column)
  v-subheader.pl-4.mt-3.pb-3 {{ $tf(filter.properties.description, filter.name) }} ({{ filter.itemCount }})
  v-layout(:class="{ 'px-4' : !$vuetify.breakpoint.xsOnly}")
    v-card.grey.lighten-4(width="100%")
      //- v-card-title(:class="{ 'pb-0' : $vuetify.breakpoint.xsOnly }")
        v-layout(row ma-0 justify-space-between pb-1)
          div.subheading(v-if="filter !== null && $vuetify.breakpoint.width > 1263") {{ $tf(filter.properties.description, filter.name) }} ({{ filter.itemCount }})
          v-flex(v-else xs12 sm6 md3)
            v-select.py-0.mt-0.mb-1(:value="filter" :items="filters" :item-text="filter => `${filter.name} (${filter.itemCount})`" return-object hide-details dense @change="select($event)")
          // Тут будет сортировка
      v-card-text(:class="{ 'px-0' : $vuetify.breakpoint.xsOnly }")
        v-container.pa-0(fluid grid-list-xl)
          v-list.v-list-responsive.overflow-x-hidden.py-0(three-line)
            template(v-for="(task, index) in tasks.task" v-if="total > 0")
              v-list-tile(:key='task.id' avatar ripple @click="selectTask(task)" color="")
                //- div
                  v-list-tile-avatar( color="primary")
                    i.v-icon.white--text.material-icons.process-default-icon(:class="task.processDefinitionId.split(':')[0]")
                  div.mt-2(v-if="$vuetify.breakpoint.xsOnly")
                    .caption.blue-grey--text {{ getCreated(task) }}
                //v-list-tile-content
                //  v-list-tile-title.mb-0
                //    v-avatar(size="32px").mr-2.primary
                //      i.v-icon.white--text.material-icons.process-default-icon(:class="task.processDefinitionId.split(':')[0]")
                //    span.font-weight-bold Timur Junussov
                //    span.ml-1.grey--text.font-weight-thin (tjunussov@gmail.com)
                  //- v-list-tile-sub-title (tjunussov@gmail.com)
                v-list-tile-content
                  v-list-tile-title.mb-0
                    span.font-weight-bold(v-html="getSubtitle(task)")
                  //  span.ml-1.grey--text.font-weight-thin - Here is content of task ....
                  v-list-tile-sub-title(v-html="getTitle(task)")
                v-list-tile-action(v-if="!$vuetify.breakpoint.xsOnly")
                  v-list-tile-action-text(v-html="getCreated(task)")
                  span: v-icon attachment
                  //- span: v-icon comment
              v-divider(inset v-if="tasks.task.length-1 !== index")

            v-flex(xs12 v-if="total == 0")
              div.nothing-right-div
                v-layout(align-center justify-center row fill-height)
                  div.headline.grey--text {{ $tf('task.emptyTaskList') }}


        template(v-if="length > 1")
          v-divider

          v-card-actions
            v-spacer
            v-pagination.mt-2(v-model="page.current" :length="length" :total-visible="5")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TaskList',

  data() {
    return {
      speedDial: false,
    }
  },

  computed: {
    ...mapGetters({
      filters: 'task/filters',
      filter: 'task/filter',
      tasks: 'task/tasks',
      total: 'task/total',
      page: 'task/page',
      profile: 'auth/profile',
    }),
    length() {
      return Math.ceil((this.total / this.page.per))
    },
  },

  watch: {
    'page.current'(newValue) {
      this.paginateTasks(newValue)
    },
  },

  methods: {
    ...mapActions({
      paginateTasks: 'task/paginateTasks',
      selectFilter: 'task/selectFilter',
      getTasks: 'task/getTasks',
    }),

    // formatFilter(filter) {
    //   return `${filter.name} (${filter.itemCount})`
    // },

    getTitle(task) {
      return this.$tf(`${task.processDefinitionId.split(':')[0]}._process.name`, `${this.tasks.processDefinition.find(x => x.id === task.processDefinitionId).name}`) + (task.description ? '. ' + task.description : '')
    },

    getSubtitle(task) {
      const assignee = this.tasks.assignee ? this.tasks.assignee.find(x => x.id === task.assignee) : null
      const taskName = this.$tf(`${task.processDefinitionId.split(':')[0]}._process.task.${task.taskDefinitionKey}`, task.name)
      if (assignee && assignee.id !== this.profile.userName) {
        const assigneeName = `<span class='text--primary'>${assignee.firstName} ${assignee.lastName}</span>`
        return `${assigneeName} - ${taskName}`
      }
      return taskName
    },

    getCreated(task) {
      return this.$moment(task.created).isSame(this.$moment(), 'day') ? this.$moment(task.created).format('HH:mm') : (this.$moment(task.created).isSame(this.$moment(), 'year') ? this.$moment(task.created).format('D MMM') : this.$moment(task.created).format('D MMM YYYY'))
    },

    select(filter) {
      this.selectFilter(filter).then(() => {
        this.getTasks()
      })
    },

    selectTask(task) {
      this.$router.push({ name: 'TaskController', params: { taskId: task.id } })
    },
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/task/TaskList.vue